// Display numbers are independent of stable catalog/financial identifiers.
export function cardLabel(card:{id:string;name?:string|null;isPersonal?:boolean}){
  if(card.isPersonal)return card.name||card.id;
  const number=/^card-(\d+)$/.exec(card.id);
  return number?String(Number(number[1])):card.name||card.id;
}
